var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["spinner", _vm.color] }, [
    _c("div", { staticClass: "bounce1" }),
    _vm._v(" "),
    _c("div", { staticClass: "bounce2" }),
    _vm._v(" "),
    _c("div", { staticClass: "bounce3" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }